import { getTrackingNavigationText as n } from "./tracking-utils.js";
const c = {
  inject: {
    trackingDataProvided: {
      from: "trackingData",
      default: () => ({})
    }
  },
  methods: {
    /**
        * Get tracking text for navigation items in the style of breadcrumbs.
        * e.g. `main item > group > sub-item`
        * If the title of the current column group is missing, use whichever title is
        * available from the previous two column groups.
        * (This description is derived by that of getTrackingNavigationText.)
        *
        * @param {Object} groupItem - navigation group item
        * @param {Number} groupIndex - navigation group item index
        * @param {Object} subItem - navigation sub item
        * @returns {String} - navigation text for tracking purposes
        */
    getTrackingText(t, a, e) {
      const { title: i, items: r } = this;
      return n(i, r, t, a, e);
    }
  }
};
export {
  c as default
};
